import type { MailFolder } from "@/lib/types/mail";
import { folderBootstrapPriority } from "@/lib/mail/folderWarmup";

/** Parent IMAP (OVH `.` ou Gmail `/`). INBOX n'est pas un conteneur — ses enfants sont au 1er niveau. */
export function folderParentName(name: string): string | null {
  let parent: string | null = null;

  if (name.includes("/")) {
    const index = name.lastIndexOf("/");
    parent = index > 0 ? name.slice(0, index) : null;
  } else if (name.includes(".")) {
    const index = name.lastIndexOf(".");
    parent = index > 0 ? name.slice(0, index) : null;
  }

  if (parent?.toUpperCase() === "INBOX") {
    return null;
  }

  return parent;
}

/** Affichage plat OVH : INBOX.Sent → depth 0 (pas caché sous Boîte de réception). */
export function normalizeMailFolders(folders: MailFolder[]): MailFolder[] {
  return folders.map((folder) => {
    const parent = folderParentName(folder.name);
    if (parent === null && folder.name.toUpperCase() !== "INBOX") {
      const rawParent = folder.name.includes(".")
        ? folder.name.slice(0, folder.name.lastIndexOf("."))
        : null;
      if (rawParent?.toUpperCase() === "INBOX") {
        return { ...folder, depth: 0 };
      }
    }
    return folder;
  });
}

/** Liste plate triée pour le sélecteur de dossier (INBOX, Envoyés, Corbeille…). */
export function flattenFoldersForPicker(folders: MailFolder[]): MailFolder[] {
  const normalized = normalizeMailFolders(folders);
  return [...normalized].sort(
    (a, b) =>
      folderBootstrapPriority(a.name) - folderBootstrapPriority(b.name) ||
      a.label.localeCompare(b.label, "fr")
  );
}
